<div class="flex items-center w-full h-full p-1.5 box-border relative">
    <input
        type="number"
        [ngModel]="value"
        (ngModelChange)="onValueChange($event)"
        class="w-full h-full bg-white/10 rounded-md border-none outline-none text-shui-text-active px-2 pr-6 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
    />
    <div class="flex flex-col shrink-0 absolute right-2 top-2 bottom-2">
        <sh-icon icon="arrow-line-up-s" button size="xs" class="cursor-pointer -mb-1" (click)="increment()"></sh-icon>
        <sh-icon icon="arrow-line-down-s" button size="xs" class="cursor-pointer -mt-1" (click)="decrement()"></sh-icon>
    </div>
</div>
